import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function ArrowUpRightIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...size !== undefined && { width: size, height: size }}
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M18.1438 5.85608C18.4974 6.20964 18.4974 6.91674 18.1438 7.2703L6.83014 18.584C6.47658 18.9376 5.76948 18.9376 5.41592 18.584C5.06237 18.2304 5.06237 17.5233 5.41592 17.1698L16.7296 5.85608C17.0832 5.50253 17.7903 5.50253 18.1438 5.85608Z"
				fill="currentColor"
			/>
			<path
				d="M17.8517 16.4646C17.3012 16.4646 16.8548 16.0185 16.8544 15.4679L16.848 7.15196L8.53208 7.14565C7.98153 7.14523 7.53544 6.6988 7.53544 6.14825C7.53544 5.5974 7.98199 5.15085 8.53284 5.15085L17.8491 5.15085C18.4014 5.15085 18.8491 5.59856 18.8491 6.15085L18.8491 15.4672C18.8491 16.018 18.4026 16.4646 17.8517 16.4646Z"
				fill="currentColor"
			/>
		</svg>
	);
}

ArrowUpRightIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default ArrowUpRightIcon;
